import React from "react"
import { Link } from 'gatsby'

export default function BtnShowAll({ categoryId }) {
  return (
    <Link to={`/category/${categoryId}`}>
        <button className="view-all-button">
        すべて見る
        </button>
    </Link>
  )
}
